import Phaser from 'phaser';
import { COLORS } from '../data/gameConstants';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    this.load.setBaseURL('');
  }

  create(): void {
    this.cameras.main.setBackgroundColor(COLORS.BACKGROUND);
    this.scene.start('PreloadScene');
  }
}
